export { Component } from './component'
